import * as React from 'react';
import { SVGProps } from 'react';

const SvgAssemblyExplorer = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='1em'
    height='1em'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <g clipPath='url(#assemblyExplorer_svg__a)'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M3.6 4v2.25h1.9v1.5H3.6v8.5h1.9v1.5H3.6V20H2V4h1.6Zm16.9 1.5h-12v3h12v-3ZM7 4v6h15V4H7Zm1.5 11.5h12v3h-12v-3ZM7 20v-6h15v6H7Z'
        fill='#000'
      />
    </g>
    <defs>
      <clipPath id='assemblyExplorer_svg__a'>
        <path fill='#fff' d='M0 0h24v24H0z' />
      </clipPath>
    </defs>
  </svg>
);

export default SvgAssemblyExplorer;
